import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JsonDataService {
  constructor(private http: HttpClient) {}

  public getValidationJsonData(): Observable<any> {
    return this.http.get('assets/json/validations.json');
  }

  public getBenefitsJsonData(): Observable<any> {
    return this.http.get('assets/json/benefits.json');
  }

  public getAffiliatesJsonData(): Observable<any> {
    return this.http.get('assets/json/affiliates.json');
  }
  
  public getWordingJsonData(): Observable<any> {
    return this.http.get('assets/json/wordings.json');
  }

  public getInformationTepmlateJsonData(): Observable<any> { 
    return this.http.get('assets/json/informationTemplates.json');
  
  }

  //public getStateIdListJsonData(): Observable<any> {
  //  return this.http.get('assets/json/stateId.json');
  //}
}
